import React, { useCallback } from 'react';
import BSForm from 'react-bootstrap/Form';
import format from 'date-fns/format';
import { useLanguageState } from '../../globalStates/LanguageState';
import BSFormControl from 'react-bootstrap/FormControl';
import DatePicker from '../DatePicker';
import InputField, { FeedbackInput } from './InputField';

interface DateFieldProps extends FeedbackInput {
    name: string
    label: string
    placeholder?: string
    required?: boolean
    value?: Date
    disabled?: boolean
    onChange?: (date: Date) => void
}

const DateFieldI: React.FC<DateFieldProps> = ({ name, label, placeholder, required, value, error, onChange, disabled }) => {
    const branding = useLanguageState().getStrings()
    const onChangeLocal = useCallback((date) => {
        onChange?.(date)
    }, [onChange])
    return (
        <BSForm.Group >
            <BSForm.Label>{label}{required ? '*' : ""}</BSForm.Label>
            <DatePicker
                id={name}
                placeholderText={placeholder || branding.configuration.dateFormat}
                dateFormat={branding.configuration.dateFormat}
                initialDate={value}
                customInput={
                    <BSForm.Control
                        name={name}
                        value={value && format(value, branding.configuration.dateFormat)}
                        maxLength={19}
                        isValid={!error}
                        isInvalid={!!error}
                    />}
                onChange={onChangeLocal}
                disabled={disabled}
            />
            {/* TODO - remvoe workaround by provind a proper input control next to the feedback*/}
            <BSFormControl.Feedback type="invalid" style={{ display: !!error ? 'block' : 'none' }}>{error}</BSFormControl.Feedback>
        </BSForm.Group>
    )
}

const DateField = (props: any) => <InputField component={DateFieldI} {...props} />
export default DateField
